import {getHeaders} from './localStorage';
import axios from 'axios';
import {api, versao} from '../config';
import errorHandling from './errorHandling';
import {
    GET_ENTREGAS,
    GET_ENTREGAS_BAIRROS,
    GET_ENTREGA,
    GET_ENTREGAS_RESUMO,
    LIMPAR_ENTREGA
} from './types';

export const getEntregas = (atual, limit, loja, filters = {}) => {
    return function (dispatch) {
        const { bairro, status, dataInicio, dataFim, entregadorId, buscaId, semLote, comLote, shippingPeriod, sortType } = filters;
        const st = sortType || 'decrescente';
        let url = `${api}/${versao}/api/entregas/admin?offset=${atual}&limit=${limit}&loja=${loja}&sortType=${encodeURIComponent(st)}`;
        if(bairro) url += `&bairro=${encodeURIComponent(bairro)}`;
        if(status) url += `&status=${encodeURIComponent(status)}`;
        if(dataInicio) url += `&dataInicio=${encodeURIComponent(dataInicio)}`;
        if(dataFim) url += `&dataFim=${encodeURIComponent(dataFim)}`;
        if(entregadorId) url += `&entregadorId=${entregadorId}`;
        if(buscaId) url += `&buscaId=${encodeURIComponent(buscaId)}`;
        if(semLote) url += `&semLote=1`;
        if(comLote) url += `&comLote=1`;
        if(shippingPeriod) url += `&shippingPeriod=${encodeURIComponent(shippingPeriod)}`;
        return axios.get(url, getHeaders())
            .then(response => {
                dispatch({ type: GET_ENTREGAS, payload: response.data });
                return response.data;
            })
            .catch(errorHandling);
    }
}

/** Resumo (sem filtro de situação), alinhado aos filtros de bairro, período, entregador e busca. */
export const getEntregasResumo = (loja, filters = {}) => {
    return function (dispatch) {
        const { bairro, dataInicio, dataFim, entregadorId, buscaId, shippingPeriod } = filters;
        let url = `${api}/${versao}/api/entregas/admin/resumo?loja=${loja}`;
        if(bairro) url += `&bairro=${encodeURIComponent(bairro)}`;
        if(dataInicio && dataFim){
            url += `&dataInicio=${encodeURIComponent(dataInicio)}`;
            url += `&dataFim=${encodeURIComponent(dataFim)}`;
        }
        if(entregadorId) url += `&entregadorId=${entregadorId}`;
        if(buscaId && String(buscaId).trim()) url += `&buscaId=${encodeURIComponent(String(buscaId).trim())}`;
        if(shippingPeriod) url += `&shippingPeriod=${encodeURIComponent(shippingPeriod)}`;
        return axios.get(url, getHeaders())
            .then(response => {
                dispatch({ type: GET_ENTREGAS_RESUMO, payload: response.data });
                return response.data;
            })
            .catch(errorHandling);
    }
}

export const getEntregasBairros = (loja) => {
    return function (dispatch) {
        return axios.get(`${api}/${versao}/api/entregas/admin/bairros?loja=${loja}`, getHeaders())
            .then(response => {
                dispatch({ type: GET_ENTREGAS_BAIRROS, payload: response.data });
                return response.data;
            })
            .catch(errorHandling);
    }
}

/** Lista completa do bairro para seleção em lote (não atualiza o reducer GET_ENTREGAS). */
export const fetchEntregasListaBairro = (loja, bairro, filters = {}) => {
    return function () {
        const { status, dataInicio, dataFim, entregadorId, buscaId, semLote, comLote, shippingPeriod, sortType } = filters;
        const st = sortType || 'decrescente';
        let url = `${api}/${versao}/api/entregas/admin?offset=0&limit=5000&loja=${loja}&sortType=${encodeURIComponent(st)}&bairro=${encodeURIComponent(bairro)}`;
        if(status) url += `&status=${encodeURIComponent(status)}`;
        if(dataInicio) url += `&dataInicio=${encodeURIComponent(dataInicio)}`;
        if(dataFim) url += `&dataFim=${encodeURIComponent(dataFim)}`;
        if(entregadorId) url += `&entregadorId=${entregadorId}`;
        if(buscaId) url += `&buscaId=${encodeURIComponent(buscaId)}`;
        if(semLote) url += `&semLote=1`;
        if(comLote) url += `&comLote=1`;
        if(shippingPeriod) url += `&shippingPeriod=${encodeURIComponent(shippingPeriod)}`;
        return axios.get(url, getHeaders())
            .then(response => response.data)
            .catch(errorHandling);
    }
}

export const getEntrega = (id, loja) => {
    return function (dispatch) {
        axios.get(`${api}/${versao}/api/entregas/admin/${id}?loja=${loja}`, getHeaders())
            .then(response => dispatch({type: GET_ENTREGA, payload: response.data}))
            .catch(errorHandling);
    }
}

export const limparEntrega = () => ({type: LIMPAR_ENTREGA});

export const updateEntregaSender = (id, loja, fieldAndValue) => {
    return function (dispatch) {
        axios.put(`${api}/${versao}/api/entregas/admin/${id}/updateSender?loja=${loja}`, fieldAndValue, getHeaders())
            .then(response => {

            })
            .catch(e => console.log(e));
    };
};

export const loteAtribuir = (loja, entregaIds, entregadorId, opts) => {
    return function () {
        const body = { entregaIds, entregadorId };
        if(opts && opts.exigirSemLoteAtual){
            body.exigirSemLoteAtual = true;
        }
        return axios.post(`${api}/${versao}/api/entregas/admin/lote/atribuir?loja=${loja}`, body, getHeaders())
            .then(response => response.data)
            .catch(errorHandling);
    };
};

/** Body: `{ loteId }` (compat) ou `{ entregaIds: string[] }` (mesmo entregador, vários lotes). */
export const loteNotificarWhatsApp = (loja, body) => {
    return function () {
        return axios.post(`${api}/${versao}/api/entregas/admin/lote/notificar-whatsapp?loja=${loja}`, body, getHeaders())
            .then(response => response.data)
            .catch(errorHandling);
    };
};

export const loteSaiuParaEntrega = (loja, entregaIds) => {
    return function () {
        return axios.post(`${api}/${versao}/api/entregas/admin/lote/saiu-para-entrega?loja=${loja}`, { entregaIds }, getHeaders())
            .then(response => response.data)
            .catch(errorHandling);
    };
};

export const loteRemoverEntrega = (loja, entregaId) => {
    return function () {
        return axios.post(`${api}/${versao}/api/entregas/admin/lote/remover-entrega?loja=${loja}`, { entregaId }, getHeaders())
            .then(response => response.data)
            .catch(errorHandling);
    };
};

/** Owner: exclui entregas (qualquer status) com data de entrega / criação anterior ao corte (dataLimite DD/MM/AAAA ou anos). */
export const purgeEntregasAntigas = (loja, dataLimite) => {
    return function () {
        return axios.post(`${api}/${versao}/api/entregas/admin/purge-entregas-antigas?loja=${loja}`, { dataLimite }, getHeaders())
            .then(response => response.data)
            .catch(errorHandling);
    };
};